import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { CreateDocumentTemplate, CreateDocumentTemplateVariables } from 'types/graphql';
import DocumentTemplateApi from '../api/DocumentTemplate.api';

/** `createDocumentTemplate` (P7-R2) over the unchanged `CreateDocumentTemplate` document. */
export function useCreateDocumentTemplate(
  options?: MutationHookOptions<CreateDocumentTemplate, CreateDocumentTemplateVariables>
) {
  const [mutate, { loading, error }] = useMutation<CreateDocumentTemplate, CreateDocumentTemplateVariables>(
    DocumentTemplateApi.CreateDocumentTemplate,
    options
  );
  const create = useCallback((variables: CreateDocumentTemplateVariables) => mutate({ variables }), [mutate]);
  return { create, loading, error };
}
